import { normalizeSearchQuery } from "@/lib/normalize-search-query";
import { orpc } from "@/utils/orpc.client";
import { ALBUM_TYPES } from "@garimpa/lib/albumTypes";
import { FORMAT_CATEGORIES } from "@garimpa/lib/formatGroups";
import { normalizeStringArray } from "@garimpa/lib/normalizeStringArray";

interface AlbumSearchQueryOptionsInput {
  query: string;
  page: number;
  genre?: string;
  style?: string;
  type?: string;
  format?: string;
  country?: string;
  artistCountry?: string;
  yearFrom?: number;
  yearTo?: number;
  labels?: string | string[];
  companies?: string | string[];
  enabled?: boolean;
}

export function hasMusicSearchFilters({
  genre,
  style,
  type,
  format,
  country,
  artistCountry,
  yearFrom,
  yearTo,
  labels,
  companies,
}: AlbumSearchQueryOptionsInput): boolean {
  return [
    genre,
    style,
    getAlbumType(type),
    getFormatCategory(format),
    country,
    artistCountry,
    yearFrom,
    yearTo,
    labels?.length,
    companies?.length,
  ].some(Boolean);
}

export function isEmptyAlbumSearch(input: AlbumSearchQueryOptionsInput): boolean {
  return input.query.trim().length === 0 && !hasMusicSearchFilters(input);
}

export function getAlbumSearchQueryOptions(input: AlbumSearchQueryOptionsInput) {
  const query = normalizeSearchQuery(input.query);
  const labels = normalizeLabels(input.labels);
  const companies = normalizeLabels(input.companies);
  return orpc.music.searchAlbums.queryOptions({
    input: {
      query,
      limit: 32,
      page: input.page,
      genre: input.genre,
      style: input.style,
      type: getAlbumType(input.type),
      format: getFormatCategory(input.format),
      country: input.country,
      artistCountry: input.artistCountry,
      yearFrom: input.yearFrom,
      yearTo: input.yearTo,
      labels: labels.length ? labels : undefined,
      companies: companies.length ? companies : undefined,
    },
    enabled: input.enabled,
  });
}

function normalizeLabels(labels: string | string[] | undefined) {
  return normalizeStringArray(labels, { trim: true, sort: true });
}

function getAlbumType(type: string | undefined) {
  if (ALBUM_TYPES.includes(type as (typeof ALBUM_TYPES)[number])) {
    return type as (typeof ALBUM_TYPES)[number];
  }
  return undefined;
}

function getFormatCategory(format: string | undefined) {
  if (FORMAT_CATEGORIES.includes(format as (typeof FORMAT_CATEGORIES)[number])) {
    return format as (typeof FORMAT_CATEGORIES)[number];
  }
  return undefined;
}
